import { coreColors } from '../../../../../styles/shared/variables';

export const mobileStandardDropdownStyle = {
    width: '100%',
    textAlign: 'center'
}

export const mobileStandardDropdownMenuItemStyle = {
    fontSize: '14px',
    color: coreColors.blue300
}


// WEBPACK FOOTER //
// ./src/components/common/dropdowns/standard/styles/mobile.js